<nz-spin [nzSpinning]="loading" [nzTip]="loadingMsg">
<form [formGroup]="form" (ngSubmit)="onSubmit()" nz-form [nzLayout]="'vertical'">

    <nz-card nzTitle="Vendor Information" class="section-card">
        <nz-row [nzGutter]="[16, 16]">
            <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label nzRequired >Name</nz-form-label>
                    <nz-form-control nzErrorTip="This field is required">
                        <input nz-input formControlName="name" name="name" placeholder="Vendor name" />
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
            <!-- <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label>Website</nz-form-label>
                    <nz-form-control nzErrorTip="Please provide correct URL">
                        <input nz-input formControlName="website" name="website" placeholder="Website URL" />
                    </nz-form-control>
                </nz-form-item>
            </nz-col> -->
            <nz-col [nzSpan]="12">
              <nz-form-item>
                <nz-form-label>Website</nz-form-label>
                <nz-form-control nzErrorTip="Please provide correct URL">
                  <nz-input-group nzAddOnBefore="https://">
                    <input nz-input formControlName="website" name="website" placeholder="Website URL" />
                  </nz-input-group>
                </nz-form-control>
              </nz-form-item>
            </nz-col>

        </nz-row>

          <nz-row [nzGutter]="[16, 16]">
                  <nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label>Registered Business Name</nz-form-label>
                      <nz-form-control nzErrorTip="This field is required">
                        <input nz-input formControlName="registered_business_name" placeholder="Registered Business Name" />
                      </nz-form-control>
                    </nz-form-item>
                  </nz-col>
                  <nz-col [nzSpan]="12">
                          <nz-form-item>
                              <nz-form-label  >Email</nz-form-label>
                              <nz-form-control nzErrorTip="This email is not Valid">
                                  <input nz-input formControlName="email" name="email" placeholder="Email" type="email" />
                              </nz-form-control>
                          </nz-form-item>
                  </nz-col>
          </nz-row>

        <nz-row [nzGutter]="[16, 16]">
            <!-- <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label  >Email</nz-form-label>
                    <nz-form-control nzErrorTip="This email is not Valid">
                        <input nz-input formControlName="email" name="email" placeholder="Email" type="email" />
                    </nz-form-control>
                </nz-form-item>
            </nz-col> -->
            <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label >Phone Number</nz-form-label>
                    <nz-form-control >
                        <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                            <ng-template #addOnBeforeTemplate>
                                <nz-select  formControlName="country_code" nzShowSearch nzAllowClear class="phone-select" nzPlaceHolder="Code">
                                    @for (countryCode of countryCodeList; track countryCode.id) {
                                        <nz-option  [nzValue]="countryCode.id" [nzLabel]="countryCode.code + ' (' + countryCode.country_name + ')'"></nz-option>
                                    }
                                </nz-select>
                            </ng-template>
                            <input formControlName="phone_number" id="phoneNumber" nz-input placeholder="Enter phone number" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
        </nz-row>

        <fieldset>
            <legend> Vendor POC </legend>
            <nz-row [nzGutter]="[16,16]">
                <nz-col *ngFor="let pocs of form.get('poc').value; let i = index; trackBy: trackByPocId" [nzSpan]="12">
                    <div class="poc-wrapper" >
                        <nz-avatar
                            [nzSrc]="getIcon(pocs?.contact_person[0])"
                            [nzSize]="54"
                            style="flex: 0 0 54px; margin: 10px;">
                        </nz-avatar>
                        <div style="flex: 1;white-space: wrap;margin-top: 12px;">
                            <div class="poc-name"><strong>{{ pocs?.contact_person }}</strong></div>
                            <div class="poc-phone" style="color: #555;">📞 {{ getCountryCode(pocs?.country_code) }} {{ pocs?.phone_number || 'N/A' }}</div>
                        </div>
                        <button nz-button nzType="text" nzSize="small" style="margin-left: 8px;"
                         nz-tooltip [nzTooltipTitle]="'Edit'"  nzTooltipPlacement="top" (click)="editPOC(pocs,$event)"
                         ><nz-icon nzType="edit" nzTheme="outline"  /></button>
                    </div>
                </nz-col>
                <nz-col [nzSpan]="12">
                    <div class="poc-wrapper add-poc" (click)="openAddPoc()">
                        <nz-avatar nzIcon="plus" [nzSize]="38" style="flex: 0 0 38px; cursor: pointer; margin-top: 8px;background:#736af7;margin-left:10px"></nz-avatar>
                        <div class="info">
                            <div class="name">Add New POC</div>
                            <p><span nz-typography nzType="secondary">Click to add new POC</span></p>
                        </div>
                    </div>
                </nz-col>
            </nz-row>
        </fieldset>
    </nz-card>

        <nz-card nzTitle="Address Information" class="section-card">
        <nz-row [nzGutter]="[16, 16]">
            <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label nzRequired >Address Line 1</nz-form-label>
                    <nz-form-control nzErrorTip="This field is required">
                        <input nz-input formControlName="address_1" name="address1" placeholder="Street, Building, etc." />
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
            <nz-col [nzSpan]="12">
                <nz-form-item>
                    <nz-form-label>Address Line 2</nz-form-label>
                    <nz-form-control>
                        <input nz-input formControlName="address_2" name="address2" placeholder="Apartment, Unit, etc." />
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
        </nz-row>

        <!-- <nz-row [nzGutter]="[16, 16]">
            <nz-col [nzSpan]="8">
                <nz-form-item>
                    <nz-form-label>Country</nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzAllowClear formControlName="country" id="country" nzPlaceHolder="Country">
                            @for (country of countryList; track country.id) {
                                <nz-option   [nzValue]="country.id" [nzLabel]="country.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
            <nz-col [nzSpan]="8">
                <form-item>
                    <nz-form-label>State</nz-form-label>
                    <nz-form-control>
                        <nz-select nzShowSearch nzAllowClear formControlName="state" id="state"  nzServerSearch  (nzOnSearch)="onSearchState($event)" nzPlaceHolder="state">
                            @for (state of stateList; track state.id) {
                                <nz-option   [nzValue]="state.id" [nzLabel]="state.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
            <nz-col [nzSpan]="8">
                <nz-form-item>
                    <nz-form-label nzRequired >City</nz-form-label>
                    <nz-form-control  nzErrorTip="This field is required">
                        <nz-select nzShowSearch nzAllowClear formControlName="city" id="city" nzServerSearch  (nzOnSearch)="onSearchCity($event)" nzPlaceHolder="city">
                            @for (city of cityList; track city.id) {
                                <nz-option   [nzValue]="city.id" [nzLabel]="city.name"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
        </nz-row> -->

        <nz-row [nzGutter]="[16, 16]">
          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label>Country</nz-form-label>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  formControlName="country"
                  id="country"
                  nzPlaceHolder="Country">
                  @for (country of countryList; track country.id) {
                    <nz-option [nzValue]="country.id" [nzLabel]="country.name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label>State</nz-form-label>
              <nz-form-control>
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  formControlName="state"
                  id="state"
                  [nzDisabled]="!form.get('country')?.value"
                  nzServerSearch
                  (nzOnSearch)="onSearchState($event)"
                  nzPlaceHolder="State">
                  @for (state of stateList; track state.id) {
                    <nz-option [nzValue]="state.id" [nzLabel]="state.name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label nzRequired>City</nz-form-label>
              <nz-form-control nzErrorTip="This field is required">
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  formControlName="city"
                  id="city"
                  [nzDisabled]="!form.get('state')?.value"
                  nzServerSearch
                  (nzOnSearch)="onSearchCity($event)"
                  nzPlaceHolder="City">
                  @for (city of cityList; track city.id) {
                    <nz-option [nzValue]="city.id" [nzLabel]="city.name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>


      </nz-card>

    <nz-card nzTitle="Services & Notes" class="section-card">
        <!-- <nz-form-item>
            <nz-form-label>Categories Serviced</nz-form-label>
            <nz-form-control>
                <nz-input-group [nzAddOnAfter]="addButton">
                    <input nz-input [ngModelOptions]="{standalone: true}" name="categories_serviced"  [(ngModel)]="categoryInput"
                        (keydown.enter)="addCategory(null)" />
                </nz-input-group>
                <ng-template #addButton class="add-button">
                    <button nz-button nzType="text" href="javascript:void(0)" (click)="addCategory($event)">Add</button>
                </ng-template>
                <div style="margin-top: 8px;">
                    <nz-tag *ngFor="let tag of form.get('categories_serviced')?.value; let i = index"
                        [nzMode]="'closeable'" (nzOnClose)="removeCategory(i)">
                        {{ tag }}
                    </nz-tag>
                </div>
            </nz-form-control>
        </nz-form-item> -->

      <nz-form-item>
        <nz-form-label nzRequired>Type of Vendor</nz-form-label>
        <nz-form-control nzErrorTip="This field is required">
          <nz-select
            formControlName="vendor_type"
            nzPlaceHolder="Select vendor type"
            nzMode="multiple"
            nzShowSearch
            nzAllowClear>
            <nz-option
              *ngFor="let type of vendorTypes"
              [nzValue]="type.id"
              [nzLabel]="type.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

        <nz-form-item>
            <nz-form-label>Notes</nz-form-label>
            <nz-form-control>
                <textarea nz-input formControlName="notes" name="notes" rows="3" placeholder="Additional notes"></textarea>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>Tax Identification</nz-form-label>
          <nz-form-control nzErrorTip="This field is required">
            <nz-select formControlName="tax_identification" nzShowSearch nzAllowClear nzPlaceHolder="Select Tax ID">
              <nz-option *ngFor="let tax of taxIdentificationTypes" [nzValue]="tax.id" [nzLabel]="tax.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired>Tax Value</nz-form-label>
          <nz-form-control nzErrorTip="Please enter tax value">
            <input
              nz-input
              formControlName="tax_input"
              placeholder="Enter tax value" />
          </nz-form-control>
        </nz-form-item>

    </nz-card>

    <!-- <nz-card nzTitle="Social" class="section-card">
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>Company LinkedIn</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="linkedin" placeholder="LinkedIn URL" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>Company Instagram</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="instagram" placeholder="Instagram URL" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-card> -->

    <nz-card nzTitle="Social" class="section-card">
  <nz-row [nzGutter]="[16, 16]">
    <nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label>Company LinkedIn</nz-form-label>
        <nz-form-control>
          <nz-input-group nzAddOnBefore="https://">
            <input nz-input formControlName="linkedin" placeholder="LinkedIn URL" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label>Company Instagram</nz-form-label>
        <nz-form-control>
          <nz-input-group nzAddOnBefore="https://">
            <input nz-input formControlName="instagram" placeholder="Instagram URL" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>
</nz-card>


</form>
</nz-spin>

<app-vendor-add-poc [data]="editPocData" [vendorID]="data?.vendor?.id" [isVisible]="isVisibleAddPoc"
 [allPOCData]="data?.poc" [pocList]="pocList"  (closeDrawer)="closeAddPocEvent($event)" (closeDrawerData)="closeAddPoc($event)" ></app-vendor-add-poc>
